export default __webpack_public_path__ + "static/media/instruccionesjuegotramite.1a67054e.png";